import { gql } from '@apollo/client';

export const GET_ALLOW_GENERAL_ROLE_APPLICATIONS = gql`
  query GetAllowGeneralRoleApplications {
    vm {
      configItem(key: "allow-general-role-applications") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;
